export const ENTITY_LINK_STATUS_PENDING = 'PENDING';
export const ENTITY_LINK_STATUS_APPROVED = 'APPROVED';
export const ENTITY_LINK_STATUS_DENIED = 'DENIED';